/**
 * Utility to preserve query parameters while removing Movmo-specific params.
 * Used after Express Checkout returns to clean up movmo_* params that the SDK
 * may not have fully scrubbed from window.location.search yet.
 */

/**
 * Remove all `movmo_*` query parameters from a search string.
 * Keeps all other parameters like `mv_internal`, `mock`, etc.
 *
 * @param search - The query string (e.g., "?mv_internal=1&movmo_exit=search_again&mock=true")
 * @returns The query string without movmo_* params (e.g., "?mv_internal=1&mock=true")
 */
export function queryWithoutMovmo(search: string): string {
    if (!search || search === "?" || search === "") {
        return "";
    }

    // Remove leading ? if present
    const cleaned = search.startsWith("?") ? search.slice(1) : search;

    // Split by & and filter out movmo_* params
    const params = cleaned
        .split("&")
        .filter((param) => {
            const key = param.split("=")[0];
            return !key.startsWith("movmo_");
        });

    // Return empty string if no params remain, otherwise return with leading ?
    return params.length > 0 ? "?" + params.join("&") : "";
}
